import { redirect } from "react-router";

import { store } from "../../../../..";
import { clubhouseActions } from "../../../../../features/clubhouse/clubhouseSlice";
import { globalActions } from "../../../../../features/global/globalSlice";
import { ILocalStorageUserData } from "../../../../../types/users";

const loader = async () => {
    const user = store.getState().auth.user;
    const userId = user?.id as ILocalStorageUserData["user"]["id"];
    const promises = [];

    !store.getState().global.settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    !store.getState().clubhouse.teams.length &&
        promises.push(store.dispatch(clubhouseActions.getTeams({ userId })));

    await Promise.all(promises);

    return store.getState().clubhouse.teams.length === 1
        ? redirect(
              `/coachs-clubhouse/team/${
                  store.getState().clubhouse.selectedTeam
              }`,
          )
        : null;
};

export default loader;
